import { Grid, Link } from '@mui/material';
import { useAuthApi, useMessage } from 'app/context';
import { useForm } from 'app/hooks';
import { Button, TextField, Typography } from 'app/shared';
import { buildErrorDetails, buildErrorMessage, ROUTES } from 'app/utils';
import { IForgotPasswordRequest } from 'generated/axios';
import { t } from 'i18next';
import { isEmpty } from 'lodash';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo_nvm from '../../../assets/logo_nvm.png';

export const ForgotPassword = () => {
  const { authApi } = useAuthApi();
  const { success, error } = useMessage();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);

  const send = useCallback(
    (form: IForgotPasswordRequest) => {
      setLoading(true);
      authApi
        .forgotPassword(form)
        .then((resp) => {
          if (resp.status >= 400) {
            return Promise.reject(resp);
          }
          success({ message: t('forgotPassword.success') as string });
          navigate(ROUTES.login);
        })
        .catch((err) => {
          error({ message: buildErrorMessage(err) });
          setErrors(buildErrorDetails(err));
        })
        .finally(() => setLoading(false));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authApi],
  );

  const { bindTextField, setErrors, submit, form } = useForm<IForgotPasswordRequest>({
    onSubmit: send,
  });

  return (
    <Grid container width={'40%'} textAlign={'center'} justifySelf={'center'} gap={4}>
      <Grid size={12} p={3}>
        <img src={logo_nvm} alt="logo big" style={{ width: '40%' }} />
      </Grid>
      <Grid size={12}>
        <Typography sx={{ fontSize: '28px', fontWeight: 600 }}>{t('forgotPassword.title')}</Typography>
      </Grid>
      <Grid size={12}>
        <Typography>{t('forgotPassword.insertEmail')}</Typography>
      </Grid>
      <Grid size={12}>
        <TextField label={t('common.email')} {...bindTextField({ field: 'email' })} />
      </Grid>
      <Grid size={12}>
        <Button onClick={submit} disabled={isEmpty(form.email)} loading={loading} sx={{ width: '150px' }}>
          {t('actions.submit')}
        </Button>
      </Grid>
      <Grid size={12}>
        <Link onClick={() => navigate(-1)}>{t('actions.back')}</Link>
      </Grid>
    </Grid>
  );
};
